import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {DiagramLayers} from '../../../../utils/network-diagram/network-diagram-constants';

@Injectable({
  providedIn: 'root'
})
export class OfflineNetworkLayersService {

  selectedLayers = {
    topology: true,
    quality: false
  };

  getSelectedLayers() {
    return _.cloneDeep(this.selectedLayers);
  }

  setSelectedLayers(layersToSetObject) {
    DiagramLayers.forEach((layer) => {
      this.selectedLayers[layer] = layersToSetObject[layer] !== undefined && layersToSetObject[layer] !== null ? layersToSetObject[layer] :
        this.selectedLayers[layer];
    });
  }
}
